import { __ } from "@wordpress/i18n";

export const DEVICES = {
	desktop: __("Desktop", "magazine-blocks"),
	tablet: __("Tablet", "magazine-blocks"),
	mobile: __("Mobile", "magazine-blocks"),
};

export const DIMENSIONS_PROPERTIES = {
	top: __("Top", "magazine-blocks"),
	right: __("Right", "magazine-blocks"),
	bottom: __("Bottom", "magazine-blocks"),
	left: __("Left", "magazine-blocks"),
};

export const SERVER_ATTRIBUTES_KEYS = [
	"categoryCount",
	"query",
	"clientId",
	"category",
	"postCount",
];

export const COMMON_BLOCK_ATTRIBUTES = {
	blockMargin: {
		type: "object",
		default: {
			dimension: 1,
			desktop: { lock: true },
		},
		style: [{ selector: "{{WRAPPER}} { margin: {{VALUE}}; }" }],
	},
	blockPadding: {
		type: "object",
		default: {
			dimension: 1,
			desktop: { lock: true },
		},
		style: [{ selector: "{{WRAPPER}} { padding: {{VALUE}}; }" }],
	},
	blockZIndex: {
		type: "number",
		style: [{ selector: "{{WRAPPER}} { z-index: {{VALUE}}; }" }],
	},
	cssID: {
		type: "string",
	},
	animation: {
		type: "string",
	},
	interaction: {
		type: "object",
	},
	position: {
		type: "object",
	},
	hideOnDesktop: {
		type: "boolean",
		style: [
			{
				selector:
					"@media (min-width:62em) { {{WRAPPER}} { display: none; } }",
			},
		],
	},
	hideOnTablet: {
		type: "boolean",
		style: [
			{
				selector:
					"@media (min-width:48em) and (max-width:62em) { {{WRAPPER}} { display: none; } }",
			},
		],
	},
	hideOnMobile: {
		type: "boolean",
		style: [
			{
				selector:
					"@media (max-width:48em) { {{WRAPPER}} { display: none; } }",
			},
		],
	},
	colReverseOnTablet: {
		type: "boolean",
		style: [
			{
				selector:
					"@media (max-width:62em) { {{WRAPPER}} > .mzb-container > .mzb-section-inner { flex-direction:column-reverse; } }",
			},
		],
	},
	colReverseOnMobile: {
		type: "boolean",
		style: [
			{
				selector:
					"@media (max-width:48em) { {{WRAPPER}} > .mzb-container > .mzb-section-inner { flex-direction:column-reverse; } }",
			},
		],
	},
	blockCSS: {
		type: "string",
	},
	className: {
		type: "string",
	},
};

export const HTML_MARKUP = [
	{ label: __("Div", "magazine-blocks"), value: "div" },
	{ label: __("Address", "magazine-blocks"), value: "address" },
	{ label: __("Article", "magazine-blocks"), value: "article" },
	{ label: __("Aside", "magazine-blocks"), value: "aside" },
	{ label: __("Blockquote", "magazine-blocks"), value: "blockquote" },
];

export const SOCIAL_URLS = {
	facebook: "https://www.facebook.com/sharer.php?u=",
	twitter: "https://twitter.com/share?url=",
	linkedin: "https://www.linkedin.com/shareArticle?url=",
	youtube: "https://www.youtube.com/",
	pinterest: "https://pinterest.com/pin/create/link/?url=",
	reddit: "https://reddit.com/submit?url=",
	vimeo: "https://vimeo.com/log_in",
	drible: "https://dribbble.com/session/new",
	blogger: "https://www.blogger.com/blog_this.pyra?t&amp;u=",
	tumblr: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=",
	telegram: "https://t.me/share/url?url=&text=",
	email: "mailto:?",
	googlePlus: "https://plus.google.com/share?url=",
	buffer: "https://bufferapp.com/add?text=&url=",
	stumbleUpon: "https://www.stumbleupon.com/submit?url=&title=",
	wordpress: "https://wordpress.com/press-this.php?u=&t=&s=&i=",
	pocket: "https://getpocket.com/save?url=&title=",
	skype: "https://web.skype.com/share?url=",
	whatsapp: "https://api.whatsapp.com/send?text=",
};
